import React, { createContext, useState, useEffect, useContext } from 'react';
import { cloneDeep } from 'lodash';
import firebase from 'firebase';
import localforage from 'localforage';
import { getComponentAvailable } from './getComponentAvailable';

const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const daysFR = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

const dayAfter = () => {
  if (new Date().getDay() + 1 === 7) return 0;
  return new Date().getDay() + 1;
};

export const ReadContext = createContext({});

export function useReadContext() {
  return useContext(ReadContext);
}

export function ReadProvider({ children, apiData, averageTime, open, start }) {
  const [currentCategory, setCurrentCategory] = useState();
  const [userInformations, setUserInformations] = useState({ name: null, firstname: null });

  const [modalData, openProductPageWithProduct] = useState({
    open: false,
    data: null,
  });

  const [lastOrder, setLastOrder] = useState(null);
  useEffect(() => {
    localforage.getItem('lastOrder').then(value => {
      if (value) setLastOrder(value);
    });
  }, []);

  const manageCard = useManageCard({ apiData, open });
  const userInfos = useUserInfo();
  const { payment_mode, delivery, deliveryInstruction, deliveryInstructionAdresse } = apiData || {};

  const value = {
    ...userInfos,
    ...manageCard,

    payment_mode,
    paymentMode: payment_mode,
    delivery,
    deliveryInstruction,
    deliveryInstructionAdresse,
    templateName: apiData?.template?.name,
    open,
    averageTime,
    start,

    currentCategory,
    setCurrentCategory,

    lastOrder,

    modalData,
    openProductPageWithProduct,

    userInformations,
    setUserInformations,
  };

  return <ReadContext.Provider value={value}>{children}</ReadContext.Provider>;
}

function useUserInfo() {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      setUser(user);
      setLoadingUser(false);
    });
    firebase.analytics().logEvent('open_application');
  }, []);

  return {
    user,
    loadingUser,
    setUser,
  };
}

function useManageCard({ apiData, open }) {
  const [service, setService] = useState({ label: 'Midi', value: 'midday' });
  const [day, setDay] = useState({
    label: daysFR[dayAfter()],
    value: days[dayAfter()],
    key: dayAfter(),
  });

  const mode = apiData?.order_mode === 'noOrder' ? 'instant' : apiData.order_mode;
  const noOrder = apiData?.order_mode === 'noOrder';

  const componentsAvailable = React.useMemo(
    () => getComponentAvailable({ categories: cloneDeep(apiData[mode]), mode, day, service, open }),
    [apiData, day, service],
  );

  return {
    categoriesProducts: apiData[mode],
    cardData: componentsAvailable,
    cardTemplate: apiData.template,
    mode,
    noOrder,
    day,
    service,
    setDay: async d => {
      setDay(d);
    },
    setService: async s => {
      setService(s);
      await localforage.setItem('service', s);
    },
  };
}

export default ReadProvider;
